import React, { useEffect, useState, useContext, useCallback } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Button, Divider, Grid } from "@material-ui/core";
// import TextField from '@material-ui/core/TextField';

import useStyles from "../../../components/styles/styles";
import { MainContext } from "../../../context/MainContext";
import { useParams } from "react-router-dom";
import Api from "../../../constant/Api";
import { useHistory } from "react-router-dom";
import { putRequest } from "../../../constant/ApiService";
import { toast } from "react-toastify";
import Input from "../../../components/utils/Input";

const DetailIndividualCustomer = props => {
  const { id } = useParams();
  const classes = useStyles();
  const history = useHistory();
  let customerData = props.location.state;
  const [customerDatas, setCustomerDatas] = useState({
    firstName: "",
    lastName: "",
    nationl_Id: "",
    phone: "",
  });

  const { disabled, setDisabled } = useContext(MainContext);

  useEffect(() => {
    if (customerData) {
      setCustomerDatas({
        firstName: customerData.firstName,
        lastName: customerData.lastName,
        security_Number: customerData.security_Number,
        phone: customerData.phone,
      });
    }
  }, [customerData]);

  const confirmCustomerFunc = () => {
    if (!customerDatas.firstName) {
      toast.error("نام را وارد کنید");
      return;
    }
    if (!customerDatas.lastName) {
      toast.error("نام خانوادگی را وارد کنید");
      return;
    }
    if (
      customerDatas.security_Number &&
      !/^[0-9]{10}$/.test(customerDatas.nationl_Id)
    ) {
      toast.error("کدملی را درست وارد کنید");
      return;
    }

    if (!customerDatas.phone) {
      toast.error("شماره همراه را وارد کنید");
      return;
    }

    if (!/^[0-9]{11}$/.test(customerDatas.phone)) {
      toast.error("شماره همراه را درست وارد  کنید");
      return;
    }
    let body = {
      id: id,
      fristName: customerDatas.firstName,
      lastName: customerDatas.lastName,
      nationl_Id: customerDatas.security_Number,
      stauts: customerData.status,
      phone: customerDatas.phone,
      work_Status: customerData.work_Status,
    };
    putRequest(`${Api.UpdateNaturalCustomer}/${id}`, body).then(res => {
      // setDisabled(true);

      if (res && res.succeeded && res.succeeded == true) {
        toast.success(res.message);
        history.push("/app/individualCustomer");
      }
    });
  };

  return (
    <Grid container>
      <PageTitle title="جزییات مشتری " />
      <Divider style={{ width: "100%", margin: "10px 0" }} />
      <Grid
        className={classes.colItem}
        item
        xl={6}
        lg={6}
        md={6}
        sm={12}
        xs={12}
      >
        <label>نام</label>
        <Input
          name="firstName"
          value={customerDatas.firstName}
          onChange={({ target }) =>
            setCustomerDatas(state => ({ ...state, firstName: target.value }))
          }
          type="text"
        />
      </Grid>
      <Grid
        className={classes.colItem}
        item
        xl={6}
        lg={6}
        md={6}
        sm={12}
        xs={12}
      >
        <label>نام خانوادگی </label>
        <Input
          name="lastName"
          value={customerDatas.lastName}
          onChange={({ target }) =>
            setCustomerDatas(state => ({ ...state, lastName: target.value }))
          }
          type="text"
        />
      </Grid>
      <Grid
        className={classes.colItem}
        item
        xl={6}
        lg={6}
        md={6}
        sm={12}
        xs={12}
      >
        <label>کد ملی</label>
        <Input
          name="nationl_Id"
          value={customerDatas.security_Number}
          onChange={({ target }) =>
            setCustomerDatas(state => ({ ...state, nationl_Id: target.value }))
          }
          type="number"
        />
      </Grid>
      <Grid
        className={classes.colItem}
        item
        xl={6}
        lg={6}
        md={6}
        sm={12}
        xs={12}
      >
        <label>شماره همراه</label>
        <Input
          value={customerDatas.phone}
          onChange={({ target }) =>
            setCustomerDatas(state => ({ ...state, phone: target.value }))
          }
          type="number"
          variant="outline"
        />
      </Grid>

      <Grid container justifyContent="space-between" direction="row-reverse">
        <Grid style={{ display: "flex" }}>
          <Button
            variant="contained"
            style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
            onClick={confirmCustomerFunc}
          >
            ثبت{" "}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default DetailIndividualCustomer;
